import { useEffect, useState } from "react";
import DashLayout from "@/components/DashLayout";
import api from "@/lib/api";
import { MessagesSquare, Users } from "lucide-react";

/**
 * Community — Coming Soon placeholder for both patient and clinician nav
 * links. The "Join Waitlist" button silently POSTs to `/api/community/waitlist`
 * — no toast, no confirmation, the user_id is quietly stored on the server
 * per the product brief.
 */
export default function Community() {
  const [enabled, setEnabled] = useState(null);
  const [joined, setJoined] = useState(false);

  useEffect(() => {
    api.get("/feature-flags")
      .then((r) => setEnabled(!!r.data?.community))
      .catch(() => setEnabled(false));
    // Track locally so we don't hammer the endpoint on repeat clicks —
    // still fire-and-forget on the server side.
    try { if (localStorage.getItem("fl_community_waitlist") === "1") setJoined(true); }
    catch { /* private mode — ignore */ }
  }, []);

  const joinSilently = () => {
    // Fire-and-forget. Never surface success/failure to the user.
    api.post("/community/waitlist", {}).catch(() => {});
    setJoined(true);
    try { localStorage.setItem("fl_community_waitlist", "1"); } catch { /* private mode */ }
  };

  return (
    <DashLayout>
      <div className="max-w-3xl mx-auto p-6" data-testid="community-page">
        <div className="fl-label text-[color:var(--fl-orange)] flex items-center gap-2">
          <MessagesSquare size={12} /> Community
        </div>
        <h1 className="fl-heading text-3xl md:text-4xl mt-2" data-testid="community-heading">
          A private space to see how others are progressing
        </h1>

        <div
          className="fl-card fl-card-elevated p-10 mt-8 text-center"
          data-testid="community-coming-soon"
          style={{ borderColor: "color-mix(in oklab, var(--fl-orange) 40%, transparent)" }}
        >
          <Users className="mx-auto text-[color:var(--fl-orange)]" size={28} />
          <div className="fl-heading text-xl mt-4">Coming soon</div>
          <p className="text-sm mt-3" style={{ color: "var(--fl-muted)" }}>
            An opt-in space for members to share wins, ask questions and cheer each other on — moderated by the Functional LAB clinical team.
            {enabled === true && " It's now live — check back after a refresh."}
          </p>

          <button
            type="button"
            onClick={joinSilently}
            disabled={joined}
            className="fl-btn text-sm mt-6 mx-auto"
            data-testid="community-join-waitlist"
            style={joined ? { opacity: 0.7, cursor: "default" } : undefined}
          >
            {joined ? "You're on the list" : "Join the waitlist"}
          </button>
        </div>
      </div>
    </DashLayout>
  );
}
